import { useMessageEvents } from 'app/hooks/useMessageEvents'

/**
 * Runs `onMessageChange` whenever a Message is created, updated or deleted on the
 * live event stream, for as long as the component is mounted and `enabled` is true.
 *
 * Replaces the old shared polling clock: every SMS surface now reacts to the same
 * stream edge instead of a timer, so the badge, the alert card and the conversation
 * list all move on the event that actually changed something.
 *
 * Fetching once on mount stays with the caller, which knows whether it has anything
 * to fetch yet.
 */
export function useMessagePoll(onMessageChange: () => void, enabled = true): void {
  useMessageEvents(() => onMessageChange(), enabled)
}
